import { Box, styled } from '@mui/material';

export const StyledBoardContainer = styled(Box)(() => {
  return {
    border: '1px solid #D8D8D8',
    borderRadius: '5px',
    minHeight: '450px',
    background: '#F9F9F9',
    padding: '20px',
    figcaption: {
      minHeight: '75px',
    },
  };
});
